module.exports = __webpack_public_path__ + "static/gallery_treehouse_1_thumb-30c257987106524fab0513e985ae24cc.jpg";